
/**
 * @desc 按左右键时判断光标是否在最左侧/最右侧
 * @param hotKeyWithArrow {function} 回调
 * @param e {object} 事件源
 */
export function processCursorPointInSide(hotKeyWithArrow, e) {
    let { target } = e;

    if (e.keyCode === 37 && target.selectionStart === 0) {
        hotKeyWithArrow && hotKeyWithArrow({ e });
    }

    if (e.keyCode === 39 && target.selectionEnd === target.value.length) {
        hotKeyWithArrow && hotKeyWithArrow({ e });
    }
}

/**
 * @desc 按上下键时判断光标是否在顶部/底部, 只有textArea才有此功能
 * @param hotKeyWithArrow {function} 回调
 * @param e {object} 事件源
 */
export function processCursorPointInTopOrBottom(hotKeyWithArrow, e) {
    let { target: { textLength, selectionStart }, keyCode } = e;

    if (keyCode === 38) {
        selectionStart === 0 &&
		hotKeyWithArrow &&
		hotKeyWithArrow({ e });
    }

    if (keyCode === 40) {
        selectionStart === textLength &&
		hotKeyWithArrow &&
		hotKeyWithArrow({ e });
    }
}
